export async function createCredential(
  decodedOptions: PublicKeyCredentialCreationOptions
): Promise<(PublicKeyCredential & { response: AuthenticatorAssertionResponse }) | undefined> {
  // Create the credential.
  // We know that this credential has a PublicKeyCredential type with a AuthenticatorAssertionResponse
  // because we're creating it over a secure connection in supported browsers.
  // PublicKeyCredential: https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredential
  // AuthenticatorAssertionResponse: https://developer.mozilla.org/en-US/docs/Web/API/AuthenticatorAssertionResponse
  const credential = (await navigator.credentials.get({
    publicKey: decodedOptions,
  })) as PublicKeyCredential & { response: AuthenticatorAssertionResponse }

  return credential
}
